import {Component, forwardRef, ViewChild} from '@angular/core';
import {UserActionBaseComponent} from '../userAction-base.component';
import {CatalogService} from 'app/Services/CatalogManagement/catalog.service';
import {MacroService} from 'app/Services/CatalogManagement/macro.service';
import {LoginService} from 'app/Services/login.service';
import {ExportFilterService} from 'app/Services/exportFilter.service';
import {CategoryFilterTreeItem} from 'app/Model/Catalog/exportFilter/categoryFilterTreeItem';
import {ValidFeatureService} from "../../../../Services/validFeature.service";
import {ValidFeature} from "../../../../Model/ValidFeature";
import {firstValueFrom} from "rxjs";
import {ValidFeatureSystem} from "../../../../Model/ValidFeatureSystem";
import {DxTreeListComponent} from "devextreme-angular";

@Component({
  selector: 'userAction-reworkVariantFeatures',
  templateUrl: 'userAction-reworkVariantFeatures.component.html',
  providers: [
    {provide: UserActionBaseComponent, useExisting: forwardRef(() => UserActionReworkVariantFeaturesComponent)}
  ],
  standalone: false
})
export class UserActionReworkVariantFeaturesComponent extends UserActionBaseComponent {

  @ViewChild('categoryTreeList') categoryTreeList: DxTreeListComponent;

  filterByCategories = false;
  categoryFilters: CategoryFilterTreeItem[] = [];
  checkedCategories: string[] = [];
  isCategoryFilterLoaded = false;

  ignoreMultivalues = false;

  isAnalyzing = false;
  hasAnalyzed = false;
  featureInCatalog: ValidFeature[] = [];
  featureSystemsInCatalog: ValidFeatureSystem[] = [];
  relevantFeatureSystemId: string;

  featureIdToVariantSettingDict: Record<string, boolean>;

  constructor(
    public loginService: LoginService,
    public macroService: MacroService,
    public catalogService: CatalogService,
    public exportFilterService: ExportFilterService,
    public featureService: ValidFeatureService,
  ) {
    super(loginService, macroService);
  }

  async ngOnInit() {
    await this.getRelevantFeatureSystemsInCatalog(null);
  }

  async getRelevantFeatureSystemsInCatalog(event: any) {
    var result = [];
    if (this.categoryFilters.length > 0) {

      result = await firstValueFrom(this.featureService.getCatalogSystems(this.catalogService.catalog.id, this.loginService.currentUser.customerId, this.getAllCheckedCategoryIds()));
    } else {
      result = await firstValueFrom(this.featureService.getCatalogSystems(this.catalogService.catalog.id, this.loginService.currentUser.customerId));
    }

    this.featureSystemsInCatalog = result;
    var technicalDetailsId = this.featureSystemsInCatalog.find(x => x.name.startsWith("udf_NMTECHNICALDETAILS-1.")).id;

    if (technicalDetailsId != null) {
      this.relevantFeatureSystemId = technicalDetailsId;
    }
  }

  async onFilterByCategoriesChanged() {
    if (this.filterByCategories && !this.isCategoryFilterLoaded) {
      this.exportFilterService
        .getCategoryFilterTreeElements(this.catalogService.selectedCatalogId, this.loginService.currentUser.customerId)
        .subscribe((filter: CategoryFilterTreeItem[]) => {
          this.categoryFilters = filter;
          this.isCategoryFilterLoaded = true;
        });
    }
  }

  async analyzeVariantFeatures() {
    this.isAnalyzing = true;
    await this.getFeaturesForCatalog();
    this.hasAnalyzed = true;
    this.isAnalyzing = false;
  }

  setIsVariant(data: any, value: boolean) {

    data.isVariant = value;
    this.featureIdToVariantSettingDict[data.id] = value;

  }

  public async canStartMacro(): Promise<boolean> {
    return this.hasAnalyzed;
  }

  public createParameterStringAsJsonString(): string {
    return JSON.stringify({
      UsedCatalogId: this.catalogService.catalog.id,
      ActiveCategoryFilters: this.getAllCheckedCategoryIds(),
      IgnoreMultiValueFeatures: this.ignoreMultivalues,
      RelevantFeatureSystemId: this.relevantFeatureSystemId,
      UsedFeatureIdListWithBoolean: this.featureIdToVariantSettingDict
    });
  }

  getAllCheckedCategoryIds(): string[] {
    if (!this.filterByCategories) return [];
    return this.categoryTreeList?.instance.getSelectedRowKeys('all') ?? [];
  }

  async getFeaturesForCatalog() {

    this.featureIdToVariantSettingDict = {};
    var dummyFS = new ValidFeatureSystem();
    dummyFS.id = this.relevantFeatureSystemId;
    dummyFS.name = "dummy";
    this.featureInCatalog = await firstValueFrom(this.featureService.getCatalogFeaturesOfSystem(this.catalogService.catalog.id, this.loginService.currentUser.customerId, dummyFS));
    
    this.featureInCatalog.forEach(f => this.featureIdToVariantSettingDict[f.id] = f.isVariant ?? false)
  }

  parseParameter(parameter: string) {
    if (!parameter)
      return;
    try {
      JSON.parse(parameter);
    } catch (error) {
      console.error('Invalid JSON string provided:', error);
    }
  }
}
